const urlForChat = window.location.href;
let stepNumber = 'v1';
let offerChoice = '';
let productChoice = '';
let stepContext = `{\r\n \"step\": \"${stepNumber}\",\r\n \"package\": [\r\n {\r\n \"key\": \"offerChoice\",\r\n \"value\": \"${offerChoice}\"\r\n },\r\n {\r\n \"key\": \"productChoice\",\r\n \"value\": \"${productChoice}\"\r\n  }\r\n ]\r\n \r\n}`;

if (urlForChat.includes('ouvrir-un-compte.html')) {
    let stepNumber = 'v1';
    let offerChoice = '';
    let productChoice = '';
    stepContext = `{\r\n \"step\": \"${stepNumber}\",\r\n \"package\": [\r\n {\r\n \"key\": \"offerChoice\",\r\n \"value\": \"${offerChoice}\"\r\n },\r\n {\r\n \"key\": \"productChoice\",\r\n \"value\": \"${productChoice}\"\r\n  }\r\n ]\r\n \r\n}`;
} else {
    stepNumber = 'v2';
    switch (localStorage.getItem('cardSelection')) {
        case 'Offre_Mastercard':
            offerChoice = 'WE-GLOBAL';
            productChoice = 'KPEUROC00002';
            break;
        case 'Offre_Mastercard_Gold_Option':
            offerChoice = 'WE-GLOBAL';
            productChoice = 'KPGOLD 00005';
            break;
        case 'Offre_Mastercard_Gold':
            offerChoice = 'WE-PREMIUM';
            productChoice = 'KPGOLD 00005';
            break;
        case 'Offre_Mastercard_World_Elite':
            offerChoice = 'WE-PREMIUM';
            productChoice = 'KPPLATI00023';
            break;
        default:
            break;
    }
    stepContext = `{\r\n \"step\": \"${stepNumber}\",\r\n \"package\": [\r\n {\r\n \"key\": \"offerChoice\",\r\n \"value\": \"${offerChoice}\"\r\n },\r\n {\r\n \"key\": \"productChoice\",\r\n \"value\": \"${productChoice}\"\r\n  }\r\n ]\r\n \r\n}`;
}

(function () {
    class creditCardsBottomSheetManager {
        constructor(el) {
            this.root = document.querySelector('.ei_contener') || document.querySelector('body');
            this.body = document.querySelector('body');
            this.el = el;
            this.cards = [...el.querySelectorAll('.carte')];
            this.triggerButtons = [...el.querySelectorAll('.carte__trigger')];
            this.moreSections = [...el.querySelectorAll('.carte__more')];
            this.bottomsheetEl = document.querySelector('.bottomsheet') || null;
            this.bottomsheet = {};
            this.optionButton = el.querySelector('.carte__option__trigger');
            this.optionData = carteOptionBottomSheet || null;
        }
        onLoad() {
            this.hideMore();
            this.onClickMore();
            this.onClickOption();
            this.createBgFade();
            this.createBottomSheet();
        }
        onClickMore() {
            this.triggerButtons.forEach((triggerButton, index) => {
                triggerButton.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.fillBottomSheet(index);
                    this.openBottomSheet();
                });
            });
        }
        onClickOption() {
            this.optionButton.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.fillBottomSheet('option');
                this.openBottomSheet();
            });
        }
        onClickReferral() {
            const that = this;
            const allReferrals = this.bottomsheetEl.querySelectorAll('sup > a');
            allReferrals.forEach((ref) => {
                ref.addEventListener('click', function (e) {
                    e.preventDefault();
                    window.location = e.target.href;
                    that.emptyBottomSheet();
                    that.closeBottomSheet();
                });
            });
        }
        onClickBody() {
            const that = this;
            const body = document.querySelector('body');
            body.addEventListener('click', function (e) {
                if (e.target.classList.value === 'fullbgcover active') {
                    that.emptyBottomSheet();
                    that.closeBottomSheet();
                }
            });
        }
        onClose() {
            this.bottomsheet.closeButton.addEventListener('click', (e) => {
                e.preventDefault();
                this.emptyBottomSheet();
                this.closeBottomSheet();
            });
        }
        hideMore() {
            this.moreSections.forEach((section) => {
                section.classList.add('hide');
            });
        }
        createBgFade() {
            const fullbgcover = document.createElement('div');
            fullbgcover.className = 'fullbgcover';
            this.root.append(fullbgcover);
            this.bottomsheet.fullbgcover = fullbgcover;
        }
        createBottomSheet() {
            if (this.bottomsheetEl !== null) {
                return;
            } else {
                const bottomsheet = document.createElement('div');
                const header = document.createElement('div');
                const headingWrapper = document.createElement('div');
                const heading = document.createElement('p');
                const content = document.createElement('p');
                const closeButton = document.createElement('div');
                const offer = document.createElement('div');
                const image = document.createElement('div');
                const cardDetails = document.createElement('div');
                const cardName = document.createElement('p');
                const cardPriceWrapper = document.createElement('div');
                const cardPrice = document.createElement('span');
                const cardMonth = document.createElement('span');
                const cardMention = document.createElement('p');
                const action = document.createElement('button');
                const body = document.createElement('div');

                header.className = 'bottomsheet__header';
                headingWrapper.className = 'bottomsheet__heading__wrapper';
                heading.className = 'bottomsheet__heading';
                content.className = 'bottomsheet__content';
                closeButton.className = 'bottomsheet__close';
                offer.className = 'bottomsheet__offer';
                image.className = 'bottomsheet__img';
                cardDetails.className = 'bottomsheet__details';
                cardName.className = 'bottomsheet__name';
                cardPriceWrapper.className = 'bottomsheet__price__wrapper';
                cardPrice.className = 'bottomsheet__price';
                cardMonth.className = 'bottomsheet__month';
                cardMention.className = 'bottomsheet__mention';
                action.className = 'bottomsheet__action';
                body.className = 'bottomsheet__body';
                bottomsheet.className = 'bottomsheet';

                headingWrapper.append(heading);
                headingWrapper.append(content);
                header.append(headingWrapper);
                header.append(closeButton);
                cardPriceWrapper.append(cardPrice);
                cardPriceWrapper.append(cardMonth);
                cardDetails.append(cardName);
                cardDetails.append(cardPriceWrapper);
                cardDetails.append(cardMention);
                offer.append(image);
                offer.append(cardDetails);
                offer.append(action);

                bottomsheet.append(header);
                bottomsheet.append(offer);
                bottomsheet.append(body);
                this.root.append(bottomsheet);
                this.bottomsheet.body = body;
                this.bottomsheet.heading = heading;
                this.bottomsheet.closeButton = closeButton;
                this.bottomsheet.content = content;
                this.bottomsheet.body = body;
                this.bottomsheet.cardPrice = cardPrice;
                this.bottomsheet.cardName = cardName;
                this.bottomsheet.cardMonth = cardMonth;
                this.bottomsheet.cardMention = cardMention;
                this.bottomsheet.action = action;
                this.bottomsheet.image = image;

                this.bottomsheetEl = bottomsheet;
                this.onClose();
            }
        }
        fillBottomSheet(index) {
            if (index === 'option' && this.optionData !== null) {
                this.bottomsheet.heading.innerHTML = this.optionData.heading;
                this.bottomsheet.content.innerHTML = this.optionData.headingContent;
                this.bottomsheet.cardName.innerHTML = this.optionData.cardName;
                this.bottomsheet.cardPrice.innerHTML =
                    this.optionData.price + '<span>&nbsp;€</span>';
                this.bottomsheet.cardMonth.innerHTML = '&nbsp;/&nbsp;mois';
                this.bottomsheet.action.innerHTML = `<a href="${this.optionData.buttonLink}" data-ga-label="Offre_Mastercard_Gold_Option" data-ga-action="Souscription" data-ga-category="CallToAction" class="button">${this.optionData.button}</a>`;
                this.bottomsheet.image.innerHTML = `<img src="${this.optionData.image}" alt=''>`;
                this.bottomsheet.body.innerHTML = this.optionData.sections;

                const actionButton = this.bottomsheet.action.querySelector('.button');
                actionButton.addEventListener('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    localStorage.setItem('cardSelection', e.target.dataset.gaLabel);
                    window.location.href = e.target.href;
                });
            } else {
                const selectedCard = this.cards[index];
                const argumentsList = selectedCard.querySelector('.carte__more').cloneNode(true);
                const img = selectedCard.querySelector('.carte__img').cloneNode(true);
                const action = selectedCard
                    .querySelector('.carte__action > .button')
                    .cloneNode(true);
                this.bottomsheet.heading.innerHTML =
                    selectedCard.querySelector('.carte__heading').innerHTML;
                this.bottomsheet.content.innerHTML =
                    selectedCard.querySelector('.carte__headcontent').innerHTML;
                this.bottomsheet.cardName.innerHTML =
                    selectedCard.querySelector('.carte__name').innerHTML;
                this.bottomsheet.cardPrice.innerHTML =
                    selectedCard.querySelector('.carte__prix').innerHTML + '<span>&nbsp;€</span>';
                this.bottomsheet.cardMonth.innerHTML =
                    selectedCard.querySelector('.carte__mois').innerHTML;
                if (selectedCard.querySelector('.carte__mention')) {
                    this.bottomsheet.cardMention.innerHTML =
                        selectedCard.querySelector('.carte__mention').innerHTML;
                }
                this.bottomsheet.action.append(action);
                this.bottomsheet.image.append(img);
                this.bottomsheet.body.append(argumentsList);

                const actionButton = this.bottomsheet.action.querySelector('.button');
                actionButton.addEventListener('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    localStorage.setItem('cardSelection', e.target.dataset.gaLabel);
                    window.location.href = e.target.href;
                });
            }
        }
        emptyBottomSheet() {
            this.bottomsheet.heading.innerHTML = '';
            this.bottomsheet.content.innerHTML = '';
            this.bottomsheet.cardName.innerHTML = '';
            this.bottomsheet.cardPrice.innerHTML = '';
            this.bottomsheet.cardMonth.innerHTML = '';
            this.bottomsheet.cardMention.innerHTML = '';
            this.bottomsheet.action.innerHTML = '';
            this.bottomsheet.image.innerHTML = '';
            this.bottomsheet.body.innerHTML = '';
        }
        openBottomSheet() {
            this.bottomsheetScroll = window.scrollY;
            this.body.classList.add('fixed');
            this.body.style.top = '-' + this.bottomsheetScroll + 'px';
            this.bottomsheetEl.classList.add('open');
            this.bottomsheet.fullbgcover.classList.add('active');
            this.onClickReferral();
            this.onClickBody();
        }

        closeBottomSheet() {
            this.body.classList.remove('fixed');
            const root = document.querySelector(':root');
            root.setAttribute('style', 'scroll-behavior: auto;');
            window.scrollBy(0, this.bottomsheetScroll);
            this.bottomsheetEl.classList.remove('open');
            this.bottomsheet.fullbgcover.classList.remove('active');
        }
        init() {
            this.onLoad();
        }
    }

    const cardManager = {
        onClick: () => {
            const allButtons = [
                ...document.querySelectorAll('.cards__list > .carte .carte__action .button')
            ];
            allButtons.forEach((button) => {
                button.onauxclick = (e) => {
                    e.preventDefault();
                    button.click();
                };

                button.addEventListener('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    localStorage.setItem('cardSelection', e.target.dataset.gaLabel);

                    switch (localStorage.getItem('cardSelection')) {
                        case 'Offre_Mastercard':
                            customProcom = '?procomCode=WE-GLOBAL&CardProductCode=KPEUROC00002';
                            break;
                        case 'Offre_Mastercard_Gold_Option':
                            customProcom = '?procomCode=WE-GLOBAL&CardProductCode=KPGOLD%2000005';
                            break;
                        case 'Offre_Mastercard_Gold':
                            customProcom = '?procomCode=WE-PREMIUM&CardProductCode=KPGOLD%2000005';
                            break;
                        case 'Offre_Mastercard_World_Elite':
                            customProcom = '?procomCode=WE-PREMIUM&CardProductCode=KPPLATI00023';
                            break;
                        default:
                            break;
                    }

                    window.location.href = e.target.href;
                });
            });
        },
        init: () => {
            cardManager.onClick();
        }
    };

    const manageSubscriptionURL = {
        onClick: () => {
            const getSubscribeButton = document.querySelector('.eer__action .button');

            getSubscribeButton.onauxclick = (e) => {
                e.preventDefault();
                getSubscribeButton.click();
            };

            getSubscribeButton.addEventListener('click', function (e) {
                e.stopPropagation();
                e.preventDefault();
                const getButtonURL = e.target.href;
                const getCurrentCardSelection = localStorage.getItem('cardSelection');
                let customProcom = '';

                if (getCurrentCardSelection !== null) {
                    switch (getCurrentCardSelection) {
                        case 'Offre_Mastercard':
                            customProcom = '?procomCode=WE-GLOBAL&CardProductCode=KPEUROC00002';
                            break;
                        case 'Offre_Mastercard_Gold_Option':
                            customProcom = '?procomCode=WE-GLOBAL&CardProductCode=KPGOLD%2000005';
                            break;
                        case 'Offre_Mastercard_Gold':
                            customProcom = '?procomCode=WE-PREMIUM&CardProductCode=KPGOLD%2000005';
                            break;
                        case 'Offre_Mastercard_World_Elite':
                            customProcom = '?procomCode=WE-PREMIUM&CardProductCode=KPPLATI00023';
                            break;
                        default:
                            break;
                    }
                    window.location = getButtonURL + customProcom;
                }
            });
        },
        init: () => {
            manageSubscriptionURL.onClick();
        }
    };

    const FAQCreateAnalyticsEvent = {
        onClick: (buttons) => {
            buttons.forEach((button) => {
                button.addEventListener('click', function (e) {
                    if (typeof trackEvent !== 'undefined') {
                        trackEvent({
                            category: 'FAQ',
                            action: 'Clic',
                            label: e.target.innerText
                        });
                    }
                });
            });
        },
        init: (buttons) => {
            FAQCreateAnalyticsEvent.onClick(buttons);
        }
    };

    window.addEventListener('DOMContentLoaded', () => {
        const getBottomSheetCard = document.querySelector('.carte[data-type="bottomsheet"]');
        const getEERSubscriptionButton = document.querySelector('.eer__action .button');
        const getAllFAQButtons = document.querySelectorAll(
            'div[itemtype="https://schema.org/FAQPage"] h2'
        );

        if (!!getAllFAQButtons) {
            FAQCreateAnalyticsEvent.init(getAllFAQButtons);
        }

        if (!!getEERSubscriptionButton) {
            manageSubscriptionURL.init();
        }

        if (!!getBottomSheetCard) {
            const sliderTarget = getBottomSheetCard.parentElement;
            const sliderWrapper = getBottomSheetCard.parentElement.parentElement.parentElement;
            sliderWrapper.classList.add('enablebottomsheet');
            new creditCardsBottomSheetManager(sliderTarget).init();
        }

        cardManager.init();
    });

    document.addEventListener('DOMContentLoaded', function () {
        const toggle = document.getElementById('collapseToggle');
        const section = document.getElementById('collapseSection');
        if (toggle){
            toggle.addEventListener('click', function () {
                if (window.innerWidth <= 600) {
                    section.classList.toggle('open');
                    toggle.classList.toggle('open');
                }
            });
            window.addEventListener('resize', function () {
                if (window.innerWidth > 600) {
                    section.classList.remove('open');
                    toggle.classList.remove('open');
                }
            });
        }
    });
})();
